export default __webpack_public_path__ + "static/roku-8273ggs-ca155820a7b914bec3f3db7860ad4d46.png";